import { createFileRoute } from "@tanstack/react-router";

import { USERS_QUERY } from "@/features/users/graphql/users-query";
import { Users } from "@/features/users/users";

export const Route = createFileRoute("/_authenticated/users/")({
  component: Users,
  loader: async ({ context }) => {
    if (context.urqlClient) {
      await context.urqlClient.query(USERS_QUERY, {}).toPromise();
    }
  },
});
